import React from 'react';
import '../css/CourtRatesTable.css';

/**
 * Compact "Court Rates" table shown above the guest booking card (ported from
 * index3.html). One row per rate band — the band's hours on the left, then
 * one price per court group across.
 *
 * Presentational only: the caller resolves bands and prices (TimeSlotSelection
 * does it with the same resolver checkout uses), so this can't drift from what
 * the guest is actually charged.
 *
 * @param {object} props
 * @param {string} [props.title] - heading over the table
 * @param {{id: string, name?: string, hours: string, prices: {key: string, label: string, value: string}[]}[]} props.rows
 * @param {number} props.columnCount - price columns per row, so every row lines up
 * @returns {JSX.Element|null} nothing when there are no bands to show
 */
function CourtRatesTable({ title = 'Court Rates', rows = [], columnCount = 1 }) {
  if (rows.length === 0) return null;

  return (
    <section className="crt-rates" aria-label={title} style={{ '--crt-col-count': Math.max(1, columnCount) }}>
      <h2 className="crt-title">{title}</h2>
      <div className="crt-list">
        {rows.map(row => (
          <div className="crt-row" key={row.id}>
            <div className="crt-time">
              {row.name && <span className="crt-band-name">{row.name}</span>}
              <span>{row.hours}</span>
            </div>
            {row.prices.map(price => (
              <div className="crt-price" key={price.key}>
                <span>{price.label}</span>
                <strong>{price.value}</strong>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

export default CourtRatesTable;
